import { render } from "./Formulario.vue?vue&type=template&id=55a02990"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"
script.render = render

export default script